import { render } from "./LeadsReportList.vue?vue&type=template&id=607b3108&scoped=true"
import script from "./LeadsReportList.vue?vue&type=script&lang=js"
export * from "./LeadsReportList.vue?vue&type=script&lang=js"

import "./LeadsReportList.vue?vue&type=style&index=0&id=607b3108&scoped=true&lang=css"

import exportComponent from "/home/paiscaler-travelcrmdev/htdocs/travelcrmdev.paiscaler.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-607b3108"]])

export default __exports__